module.exports = __webpack_public_path__ + "static/media/photo-2.42cd5560.jpg";